import { render, staticRenderFns } from "./PhoneDetailModal.vue?vue&type=template&id=54af932d&scoped=true"
import script from "./PhoneDetailModal.vue?vue&type=script&lang=js"
export * from "./PhoneDetailModal.vue?vue&type=script&lang=js"
import style0 from "./PhoneDetailModal.vue?vue&type=style&index=0&id=54af932d&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54af932d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54af932d')) {
      api.createRecord('54af932d', component.options)
    } else {
      api.reload('54af932d', component.options)
    }
    module.hot.accept("./PhoneDetailModal.vue?vue&type=template&id=54af932d&scoped=true", function () {
      api.rerender('54af932d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/statistic/components/campusPreview/PhoneDetailModal.vue"
export default component.exports